const routes = [
  {
    path: '/student/interview',
    component: () => import('@/views/student/followUpGraduate/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'GraduateInterview',
        component: () =>
          import('@/views/student/followUpGraduate/GraduateInterview.vue'),
      },
      {
        path: '/student/egressquestionnaire/:studentExitId?',
        name: 'EgressQuestionnaire',
        component: () =>
          import('@/views/student/followUpGraduate/EgressQuestionnaire.vue'),
      },
    ],
  },
];

export default routes;
